/* External */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Styles */
import './LanderTitle.scss';

function LanderTitle({ titleId }) {
  return (
    <div className="dtv-lander-title">
      <FormattedMessage id={titleId} defaultMessage="Lander Title" />
    </div>
  );
}

LanderTitle.propTypes = {
  titleId: PropTypes.string.isRequired,
};

export default LanderTitle;
